import React, { useState, useEffect } from 'react';
import './TopLevelStocks.css';

const TopLevelStocks = ({ onBack }) => {
  const [stocks, setStocks] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  useEffect(() => {
    
  }, []);

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedStocks = React.useMemo(() => {
    if (!sortConfig.key) return stocks;
    
    return [...stocks].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }, [stocks, sortConfig]);

  return (
    <div className="vb-page">
      <header className="intraday-header">
        <div className="intraday-header-container">
          <div className="logo">
            <img src="images/Final Font Stocks4U1.png" className="logo-text" alt="Stocks4U"/>
          </div>
          <div className="intraday-user">
            <button onClick={onBack}>← Back to Dashboard</button>
          </div>
        </div>
      </header>

      <div className="vb-content">
        <h1>Intraday Scan <span className="info-icon">ℹ️</span></h1>

        <div className="vb-category-card">
          <h3>Top Level Stocks</h3>
          <p>How to use ?</p>
        </div>

        <div className="vb-filters">
          <span>Filter By:</span>
          <span>( Criteria Volume )</span>
        </div>

        <div className="vb-table">
          <div className="vb-table-header">
            <span>Star</span>
            <span onClick={() => handleSort('name')} className={sortConfig.key === 'name' ? `sorted ${sortConfig.direction}` : ''}>Name</span>
            <span onClick={() => handleSort('change')} className={sortConfig.key === 'change' ? `sorted ${sortConfig.direction}` : ''}>Percentage Change</span>
            <span>SIGNALS</span>
          </div>

          {sortedStocks.map((row) => {
            const isPositive = row.change && !row.change.includes('-');
            return (
              <div key={row.id} className={`vb-table-row ${row.highlight ? 'highlight' : ''}`}>
                <span>{row.highlight ? '⭐' : '☆'}</span>
                <span>{row.name}</span>
                <span>
                  {row.change && (
                    <span className={`change-badge ${isPositive ? 'positive' : 'negative'}`}>
                      {row.change}
                    </span>
                  )}
                </span>
                <span style={{ color: isPositive ? '#10b981' : '#ef4444', fontSize: '1.2rem', fontWeight: 'bold' }}>
                  {isPositive ? '↑' : '↓'}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TopLevelStocks;
